import React, { Dispatch, useEffect, useState } from "react"
import { Button, Input, Modal } from "antd"
import { BarcodeOutlined } from "@ant-design/icons"

const TrayIdModal = (props: { setTrayModal: Dispatch<boolean>, trayModal: boolean, setTrayId: Dispatch<string | undefined>, trayId: string | undefined }) => {
  const { setTrayModal, trayModal, setTrayId, trayId } = props
  const [tmp, setTmp] = useState<string | undefined>(trayId)

  useEffect(() => {
    if (trayId && trayId.length > 0)
      setTmp(trayId)
  }, [trayId])

  return (
    <Modal open={trayModal}
      maskClosable={false}
      keyboard={false}
      destroyOnClose={true}
      footer={[
        <Button key={"cancel"} onClick={() => { setTrayModal(false); setTmp(trayId) }}>Annuler</Button>,
        <Button style={{ backgroundColor: "#10b981 ", color: "white" }} key={"ok"} onClick={() => { setTrayModal(false); setTrayId(tmp) }}>Valider</Button>
      ]}
      title="Saisissez l'id du plateau"
      onCancel={() => { setTrayModal(false); setTmp(trayId) }}
    >
      <h4>
        Veuillez saisir l'id du plateau
      </h4>
      <Input allowClear defaultValue={trayId} value={tmp} prefix={<BarcodeOutlined />} onChange={(e) => {
        setTmp(e.target.value)
      }} placeholder="Identifiant de plateau" />
    </Modal>
  )
}

export default TrayIdModal